import React from 'react'
import styled from 'styled-components'

import Container from './../../common/components/Container';
import Row from './../../common/components/Row';
import Col from './../../common/components/Col';
import Logo from './../../common/components/Logo';
// import Button from './../../common/components/Button';
import Socials from './Socials';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
  width: 100%;
  background-color: #0D609D;
  color: #ffffff;
  padding: 48px 0px;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`;
const Copy = styled.div.withConfig({displayName:'-Copy'})`
  font-size: 8px;
`;
const Menu = styled.div.withConfig({displayName:'-Menu'})`
`;
const Item = styled.a`
  font-size: 8px;
  text-transform: uppercase;
  text-decoration: underline;
  color: #ffffff;
`;
const Item2 = styled.a`
  text-decoration: underline;
  color: #ffffff;
`;
const SocialsWrapper = styled.div.withConfig({displayName:'-SocialsWrapper'})`
  margin-top: 8px;
  margin-bottom: 24px;
`;

const Footer = () => {
  return (
    <Wrapper>
      <Container>
        <Row>
          <Col width={2}>
            <Logo height="53px" inverse />
          </Col>
          <Col width={5}>
            <Title>Follow us</Title>
            <SocialsWrapper>
              <Socials inverse />
            </SocialsWrapper>
            <Copy>&copy; CESI S.p.A. 2019 - VAT No. IT00793580150</Copy>
            <Menu>
              <Item href="https://www.cesi.it/all-rights-reserved/" target="_blank">All rights reserved</Item>
              <Item href="https://www.cesi.it/legal-notice/" target="_blank">Legal notice</Item>
              <Item href="https://www.cesi.it/privacy-policy/" target="_blank">Privacy policy</Item>
            </Menu>
          </Col>
          <Col width={5}>
            <Menu>
              <Title>Link utili</Title>
              <Item2 href="http://oz-cesi-cile-staging.s3-website-eu-west-1.amazonaws.com/it/geo/san-isidro" target="_blank">San Isidro</Item2><br/>
              Valori di fondo - <Item2 href="/A01_02-1.jpg" target="_blank">Slide 1</Item2> - <Item2 href="/A01_02-2.jpg" target="_blank">Slide 2</Item2><br/>
              <Item2 href="/Modello_excel_caricamento_dati.xlsx" target="_blank">Modello Excel caricamento dati</Item2>
            </Menu>            
          </Col>
        </Row>
      </Container>
    </Wrapper>
  )
}

export default Footer
